import angular from 'angular'
import dcGoBack from './goback'
export default angular.module('goback', [])
    .directive('dcGoBack', dcGoBack)